import React from 'react';
import Icon from '../../components/Icon';

const QuestionCard = ({ question, onSelect }) => {
  const statusMap = {
    unanswered: { text: "Unanswered", bg: "bg-gray-100", text_color: "text-gray-600" },
    'in-review': { text: "In Review", bg: "bg-amber-100", text_color: "text-amber-700" },
    'needs-revision': { text: "Needs Revision", bg: "bg-red-100", text_color: "text-red-700" },
    passed: { text: "Passed", bg: "bg-emerald-100", text_color: "text-emerald-700" },
  };

  // Check if the due date is in the past (ignoring the time of day)
  const isOverdue = question.dueDate && new Date(question.dueDate) < new Date().setHours(0, 0, 0, 0);

  const getAction = () => {
    switch (question.status) {
      case 'unanswered':
      case 'needs-revision':
        return <button onClick={() => onSelect(question, 'answer')} className="font-semibold py-2 px-4 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white text-sm transition-colors">Answer</button>;
      case 'in-review':
        return <button onClick={() => onSelect(question, 'answer')} className="font-semibold py-2 px-4 rounded-md bg-amber-500 hover:bg-amber-600 text-white text-sm transition-colors">Edit Answer</button>;
      case 'passed':
        return <button onClick={() => onSelect(question, 'view')} className="font-semibold py-2 px-4 rounded-md bg-emerald-500 hover:bg-emerald-600 text-white text-sm transition-colors">View Feedback</button>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5 mb-4 transition-shadow hover:shadow-md">
      {/* Display admin feedback if it exists */}
      {question.feedback && (question.status === 'needs-revision' || question.status === 'passed') && (
        <div className="mb-4 p-3 bg-slate-50 border-l-4 border-slate-300 rounded-r-md">
            <p className="font-semibold text-slate-700 text-sm">Admin Feedback:</p>
            <p className="text-slate-600 text-sm italic">"{question.feedback}"</p>
        </div>
      )}

      <div className="flex justify-between items-start gap-4">
        <h3 className="text-lg font-bold text-slate-800">{question.text}</h3>
        <span className={`px-3 py-1 text-xs font-medium rounded-full whitespace-nowrap ${statusMap[question.status]?.bg} ${statusMap[question.status]?.text_color}`}>
          {statusMap[question.status]?.text || 'Unknown'}
        </span>
      </div>

      {/* Display Tags */}
      {question.tags && question.tags.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
            {question.tags.map(tag => (
                <span key={tag} className="bg-indigo-100 text-indigo-700 text-xs font-medium px-2.5 py-1 rounded-full">{tag}</span>
            ))}
        </div>
      )}

      <div className="flex justify-between items-center mt-4">
        <div className="flex items-center gap-4 text-sm text-slate-500">
            <p>Marks: <span className="font-semibold text-slate-700">{question.marks}</span></p>
            {question.createdAt && (
                <div className="flex items-center gap-1.5">
                    <Icon name="Clock" className="w-4 h-4" />
                    <span>Posted: {new Date(question.createdAt.seconds * 1000).toLocaleString()}</span>
                </div>
            )}
            {question.dueDate && (
                <div className={`flex items-center gap-1.5 ${isOverdue && question.status !== 'passed' ? 'text-red-600 font-semibold' : ''}`}>
                    <Icon name="Calendar" className="w-4 h-4" />
                    <span>Due: {new Date(question.dueDate).toLocaleDateString()}</span>
                </div>
            )}
        </div>
        {getAction()}
      </div>
    </div>
  );
};

export default QuestionCard;